import { Component, Input, OnInit } from '@angular/core';
// import { Router } from '@angular/router';
import { Router, NavigationStart, Event as NavigationEvent } from '@angular/router';
import { Subject } from 'rxjs';
import { AdministartionService } from 'src/app/service/administartion.service';
import { TrailerNumberHistoryComponent } from '../history/trailer-number-history/trailer-number-history.component';

@Component({
  selector: 'app-notification-message',
  templateUrl: './notification-message.component.html',
  styleUrls: ['./notification-message.component.scss']
})
export class NotificationMessageComponent implements OnInit {
  @Input()
  successMessage: string = ""
  @Input()
  errorMessage: string = ""
  @Input()
  CommonMessage: string = ""
  @Input()
  Complianerror = ''
  public complianceComp: boolean = false
  public route: any
  public currentURL: any
  constructor(private router: Router, public adminService: AdministartionService) {

    this.router.events.subscribe((event: NavigationEvent) => {
      if (event instanceof NavigationStart) {
        this.currentURL = event.url;
        if (event.url != '/administration/complaince-review') {
          this.complianceComp = false
          this.Complianerror = ''

        }
      }
    });
  }

  ngOnInit(): void {
    this.adminService.castCompl.subscribe(user => {
      if (this.currentURL == '/administration/complaince-review') {

        this.complianceComp = true
        this.Complianerror = user
      };
    })
  }

  shoCompliance(msg: any) {
    this.complianceComp = true
    this.Complianerror = msg
  }

  close() {
    this.Complianerror = ''
  }

  checkCommonMessage(): boolean {
    if (this.CommonMessage != '' && this.CommonMessage != undefined)
      return true;
    return false
  }
}